<template>
  <el-form :model="form" ref="form" label-position="top">
    <el-row>
      <el-col :span="12">
        <el-form-item label="最大可传输数据的容量" prop="maxsize">
          <el-input-number v-model="form.maxsize"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否开启https" prop="ssl">
          <el-switch v-model="form.ssl" active-text="开" inactive-text="关">
          </el-switch>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="线程数" prop="threshold">
          <el-input v-model="form.threshold" />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import rApi from '@/api/senior/seniorconf';
let datafault = {};
export default {
  components: { rApi },
  props: {
    uuid: '',
  },
  data() {
    return {
      form: {
        maxsize: 4194304,
        ssl: false,
        threshold: 3000,
      },
    };
  },
  mounted() {
    if (this.uuid) {
      rApi.getCsSenior(this.uuid).then((resp) => {
        var _form = JSON.parse(resp.data);
        this.form.maxsize = _form.maxsize ? _form.maxsize : this.form.maxsize;
        this.form.ssl =
          _form.ssl || _form.ssl === false ? _form.ssl : this.form.ssl;
        this.form.threshold = _form.threshold
          ? _form.threshold
          : this.form.threshold;
      });
    }
  },
  methods: {
    save() {
      if (this.uuid) {
        rApi
          .doSaveForCsSenior(this.uuid, JSON.stringify(this.form))
          .then(() => this.$message.success('操作成功！'));
      }
      return this.form;
    },
  },
};
</script>
<style scoped></style>
